import React from "react";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers";

const DatePicker = ({ format, slotProps, ...props }) => {
  if (typeof slotProps === "function") {
    return (
      <MuiDatePicker format={format || "DD/MM/YYYY"} {...props} slotProps={slotProps} />
    );
  }
  const sp = slotProps || {};
  const fieldSP = sp.field || {};
  const textFieldSP = {
    ...(sp.textField || {}),
    ...(fieldSP.slotProps?.textField || {}),
  };
  const mergedSlotProps = {
    ...sp,
    field: {
      ...fieldSP,
      slotProps: {
        ...(fieldSP.slotProps || {}),
        textField: {
          ...textFieldSP,
          sx: {
            "& .MuiSvgIcon-root": { color: "black" },
            ...(textFieldSP.sx || {}),
          },
        },
      },
    },
  };
  return (
    <MuiDatePicker
      format={format || "DD/MM/YYYY"}
      {...props}
      slotProps={mergedSlotProps}
    />
  );
};

export default DatePicker;
